/**
 * @generated SignedSource<<d531566e0c751d9db348e1b3f441da89>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ImageGenerationUpdateInput = {
  categoriesForEdit: ReadonlyArray<number>;
  categoriesForGeneration: ReadonlyArray<number>;
  id: string;
  numberOfImagesEdit: number;
  numberOfImagesGeneration: number;
  showInImages: boolean;
  showInUpload: boolean;
  showInVerticalBar: boolean;
};
export type aiImageGenEditor_UpdateMutation$variables = {
  input: ImageGenerationUpdateInput;
};
export type aiImageGenEditor_UpdateMutation$data = {
  readonly updateImageGeneration: {
    readonly id: string;
  };
};
export type aiImageGenEditor_UpdateMutation = {
  response: aiImageGenEditor_UpdateMutation$data;
  variables: aiImageGenEditor_UpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImageGenerationDTO",
    "kind": "LinkedField",
    "name": "updateImageGeneration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiImageGenEditor_UpdateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiImageGenEditor_UpdateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b6333382266545a06ad5aa515290ccf9",
    "id": null,
    "metadata": {},
    "name": "aiImageGenEditor_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation aiImageGenEditor_UpdateMutation(\n  $input: ImageGenerationUpdateInput!\n) {\n  updateImageGeneration(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cece22839ed69d144fd87175a7daf3f4";

export default node;
